import API_BASE_URL from '../config/api';
const USE_REAL_API = true;

export const createRevolutOrder = async (orderData) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/orders/revolut`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(orderData),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to create order');
  }

  return response.json();
};

export const createGuestRevolutOrder = async (orderData) => {
  // No token required for guest orders
  const response = await fetch(`${API_BASE_URL}/orders/guest/revolut`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(orderData),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to create guest order');
  }

  return response.json();
};

export const getRevolutOrderStatus = async (orderId) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/orders/revolut/${orderId}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to get order status');
  }

  return response.json();
};

const authHeaders = () => {
  const token =
    typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Mock data for development
const mockOrders = [
  {
    id: 1,
    orderNumber: 'ORD-2024-001',
    customerId: 1,
    customerName: 'John Doe',
    customerEmail: 'john.doe@example.com',
    status: 'pending',
    paymentStatus: 'pending',
    shippingStatus: 'not_shipped',
    totalAmount: 245.5,
    subtotal: 220.0,
    shippingCost: 15.5,
    tax: 10.0,
    currency: 'USD',
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-01-15T10:30:00Z',
    shippingAddress: {
      firstName: 'John',
      lastName: 'Doe',
      company: 'ABC Construction',
      address1: '123 Main Street',
      address2: 'Suite 100',
      city: 'New York',
      state: 'NY',
      zipCode: '10001',
      country: 'USA',
      phone: '+1 (555) 123-4567',
    },
    billingAddress: {
      firstName: 'John',
      lastName: 'Doe',
      company: 'ABC Construction',
      address1: '123 Main Street',
      address2: 'Suite 100',
      city: 'New York',
      state: 'NY',
      zipCode: '10001',
      country: 'USA',
      phone: '+1 (555) 123-4567',
    },
    items: [
      {
        id: 1,
        productId: 1,
        productName: 'Professional Paint Brush Set',
        productSku: 'PAINT-001',
        quantity: 2,
        unitPrice: 45.0,
        totalPrice: 90.0,
        image: '/assets/product-image.webp',
      },
      {
        id: 2,
        productId: 2,
        productName: 'Safety Work Jacket',
        productSku: 'WEAR-001',
        quantity: 1,
        unitPrice: 130.0,
        totalPrice: 130.0,
        image: '/assets/product-image.webp',
      },
    ],
    shipping: {
      method: 'standard',
      carrier: 'DHL',
      trackingNumber: null,
      estimatedDelivery: '2024-01-20T00:00:00Z',
      actualDelivery: null,
    },
    payment: {
      method: 'credit_card',
      transactionId: 'txn_123456789',
      last4: '4242',
      brand: 'visa',
      status: 'pending',
    },
    notes: 'Please deliver during business hours',
  },
  {
    id: 2,
    orderNumber: 'ORD-2024-002',
    customerId: 2,
    customerName: 'Sarah Johnson',
    customerEmail: 'sarah.j@example.com',
    status: 'processing',
    paymentStatus: 'paid',
    shippingStatus: 'preparing',
    totalAmount: 189.5,
    subtotal: 170.0,
    shippingCost: 12.5,
    tax: 7.0,
    currency: 'USD',
    createdAt: '2024-01-14T14:20:00Z',
    updatedAt: '2024-01-16T09:15:00Z',
    shippingAddress: {
      firstName: 'Sarah',
      lastName: 'Johnson',
      company: 'Johnson & Associates',
      address1: '456 Oak Avenue',
      address2: '',
      city: 'Los Angeles',
      state: 'CA',
      zipCode: '90210',
      country: 'USA',
      phone: '+1 (555) 987-6543',
    },
    billingAddress: {
      firstName: 'Sarah',
      lastName: 'Johnson',
      company: 'Johnson & Associates',
      address1: '456 Oak Avenue',
      address2: '',
      city: 'Los Angeles',
      state: 'CA',
      zipCode: '90210',
      country: 'USA',
      phone: '+1 (555) 987-6543',
    },
    items: [
      {
        id: 3,
        productId: 3,
        productName: 'Industrial Primer',
        productSku: 'PAINT-002',
        quantity: 3,
        unitPrice: 25.0,
        totalPrice: 75.0,
        image: '/assets/product-image.webp',
      },
      {
        id: 4,
        productId: 4,
        productName: 'Work Boots',
        productSku: 'WEAR-002',
        quantity: 1,
        unitPrice: 95.0,
        totalPrice: 95.0,
        image: '/assets/product-image.webp',
      },
    ],
    shipping: {
      method: 'express',
      carrier: 'DHL',
      trackingNumber: 'DHL123456789',
      estimatedDelivery: '2024-01-18T00:00:00Z',
      actualDelivery: null,
    },
    payment: {
      method: 'credit_card',
      transactionId: 'txn_987654321',
      last4: '5555',
      brand: 'mastercard',
      status: 'paid',
    },
    notes: '',
  },
  {
    id: 3,
    orderNumber: 'ORD-2024-003',
    customerId: 3,
    customerName: 'Mike Wilson',
    customerEmail: 'mike.wilson@email.com',
    status: 'shipped',
    paymentStatus: 'paid',
    shippingStatus: 'in_transit',
    totalAmount: 450.25,
    subtotal: 420.0,
    shippingCost: 20.25,
    tax: 10.0,
    currency: 'USD',
    createdAt: '2024-01-10T16:45:00Z',
    updatedAt: '2024-01-17T11:30:00Z',
    shippingAddress: {
      firstName: 'Mike',
      lastName: 'Wilson',
      company: '',
      address1: '789 Pine Street',
      address2: 'Apt 2B',
      city: 'Chicago',
      state: 'IL',
      zipCode: '60601',
      country: 'USA',
      phone: '+1 (555) 456-7890',
    },
    billingAddress: {
      firstName: 'Mike',
      lastName: 'Wilson',
      company: '',
      address1: '789 Pine Street',
      address2: 'Apt 2B',
      city: 'Chicago',
      state: 'IL',
      zipCode: '60601',
      country: 'USA',
      phone: '+1 (555) 456-7890',
    },
    items: [
      {
        id: 5,
        productId: 5,
        productName: 'Safety Helmet',
        productSku: 'WEAR-003',
        quantity: 2,
        unitPrice: 85.0,
        totalPrice: 170.0,
        image: '/assets/product-image.webp',
      },
      {
        id: 6,
        productId: 6,
        productName: 'Work Gloves',
        productSku: 'WEAR-004',
        quantity: 5,
        unitPrice: 50.0,
        totalPrice: 250.0,
        image: '/assets/product-image.webp',
      },
    ],
    shipping: {
      method: 'standard',
      carrier: 'DHL',
      trackingNumber: 'DHL987654321',
      estimatedDelivery: '2024-01-22T00:00:00Z',
      actualDelivery: null,
    },
    payment: {
      method: 'credit_card',
      transactionId: 'txn_456789123',
      last4: '1234',
      brand: 'visa',
      status: 'paid',
    },
    notes: 'Fragile items - handle with care',
  },
];

// Generate additional orders to reach 50+
const generateAdditionalOrders = () => {
  const additionalOrders = [];
  let id = 4;

  const statuses = [
    'pending',
    'processing',
    'shipped',
    'delivered',
    'cancelled',
  ];
  const paymentStatuses = ['pending', 'paid', 'failed', 'refunded'];
  const shippingStatuses = [
    'not_shipped',
    'preparing',
    'in_transit',
    'delivered',
    'cancelled',
  ];
  const paymentMethods = ['credit_card', 'paypal', 'bank_transfer'];
  const shippingMethods = ['standard', 'express', 'overnight'];
  const carriers = ['DHL', 'FedEx', 'UPS'];

  const cities = [
    'New York',
    'Los Angeles',
    'Chicago',
    'Houston',
    'Phoenix',
    'Philadelphia',
    'San Antonio',
    'San Diego',
    'Dallas',
    'San Jose',
    'Austin',
    'Jacksonville',
    'Fort Worth',
    'Columbus',
    'Charlotte',
    'San Francisco',
    'Indianapolis',
    'Seattle',
    'Denver',
    'Washington',
    'Boston',
    'El Paso',
    'Nashville',
    'Detroit',
  ];

  const states = [
    'NY',
    'CA',
    'IL',
    'TX',
    'AZ',
    'PA',
    'TX',
    'CA',
    'TX',
    'CA',
    'TX',
    'FL',
    'TX',
    'OH',
    'NC',
    'CA',
    'IN',
    'WA',
    'CO',
    'DC',
    'MA',
    'TX',
    'TN',
    'MI',
  ];

  const productNames = [
    'Professional Paint Brush',
    'Industrial Primer',
    'Safety Work Jacket',
    'Work Boots',
    'Safety Helmet',
    'Work Gloves',
    'Paint Roller',
    'Drop Cloth',
    'Masking Tape',
    'High-Vis Vest',
    'Coveralls',
    'Apron',
    'Safety Belt',
    'Hard Hat',
    'Steel Toe Boots',
  ];

  for (let i = 0; i < 47; i++) {
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    const paymentStatus =
      paymentStatuses[Math.floor(Math.random() * paymentStatuses.length)];
    const shippingStatus =
      shippingStatuses[Math.floor(Math.random() * shippingStatuses.length)];
    const city = cities[Math.floor(Math.random() * cities.length)];
    const state = states[Math.floor(Math.random() * states.length)];
    const subtotal = Math.round((Math.random() * 500 + 50) * 100) / 100;
    const shippingCost = Math.round((Math.random() * 30 + 10) * 100) / 100;
    const tax = Math.round(subtotal * 0.08 * 100) / 100;
    const totalAmount = subtotal + shippingCost + tax;
    console.log(totalAmount);
    const itemCount = Math.floor(Math.random() * 5) + 1;
    const createdAt = new Date(
      Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000
    );
    const updatedAt = new Date(
      createdAt.getTime() + Math.random() * 7 * 24 * 60 * 60 * 1000
    );

    const items = [];
    for (let j = 0; j < itemCount; j++) {
      const unitPrice = Math.round((Math.random() * 100 + 10) * 100) / 100;
      const quantity = Math.floor(Math.random() * 3) + 1;
      items.push({
        id: j + 1,
        productId: Math.floor(Math.random() * 100) + 1,
        productName:
          productNames[Math.floor(Math.random() * productNames.length)],
        productSku: `SKU-${Math.floor(Math.random() * 1000)}`,
        quantity,
        unitPrice,
        totalPrice: Math.round(unitPrice * quantity * 100) / 100,
        image: '/assets/product-image.webp',
      });
    }

    const recalculatedSubtotal = items.reduce(
      (sum, item) => sum + item.totalPrice,
      0
    );
    const recalculatedTax = Math.round(recalculatedSubtotal * 0.08 * 100) / 100;
    const recalculatedTotal =
      recalculatedSubtotal + shippingCost + recalculatedTax;

    additionalOrders.push({
      id: id++,
      orderNumber: `ORD-2024-${id.toString().padStart(3, '0')}`,
      customerId: Math.floor(Math.random() * 50) + 1,
      customerName: `Customer ${id}`,
      customerEmail: `customer${id}@example.com`,
      status,
      paymentStatus,
      shippingStatus,
      totalAmount: recalculatedTotal,
      subtotal: recalculatedSubtotal,
      shippingCost,
      tax: recalculatedTax,
      currency: 'USD',
      createdAt: createdAt.toISOString(),
      updatedAt: updatedAt.toISOString(),
      shippingAddress: {
        firstName: 'Customer',
        lastName: `${id}`,
        company: Math.random() > 0.5 ? `Company ${id}` : '',
        address1: `${Math.floor(Math.random() * 9999) + 1} Main Street`,
        address2:
          Math.random() > 0.7 ? `Suite ${Math.floor(Math.random() * 100)}` : '',
        city,
        state,
        zipCode: `${Math.floor(Math.random() * 90000) + 10000}`,
        country: 'USA',
        phone: `+1 (555) ${Math.floor(Math.random() * 900) + 100}-${Math.floor(Math.random() * 9000) + 1000
          }`,
      },
      billingAddress: {
        firstName: 'Customer',
        lastName: `${id}`,
        company: Math.random() > 0.5 ? `Company ${id}` : '',
        address1: `${Math.floor(Math.random() * 9999) + 1} Main Street`,
        address2:
          Math.random() > 0.7 ? `Suite ${Math.floor(Math.random() * 100)}` : '',
        city,
        state,
        zipCode: `${Math.floor(Math.random() * 90000) + 10000}`,
        country: 'USA',
        phone: `+1 (555) ${Math.floor(Math.random() * 900) + 100}-${Math.floor(Math.random() * 9000) + 1000
          }`,
      },
      items,
      shipping: {
        method:
          shippingMethods[Math.floor(Math.random() * shippingMethods.length)],
        carrier: carriers[Math.floor(Math.random() * carriers.length)],
        trackingNumber:
          Math.random() > 0.3
            ? `${carriers[Math.floor(Math.random() * carriers.length)]
            }${Math.floor(Math.random() * 1000000000)}`
            : null,
        estimatedDelivery: new Date(
          createdAt.getTime() + Math.random() * 14 * 24 * 60 * 60 * 1000
        ).toISOString(),
        actualDelivery:
          status === 'delivered'
            ? new Date(
              createdAt.getTime() + Math.random() * 10 * 24 * 60 * 60 * 1000
            ).toISOString()
            : null,
      },
      payment: {
        method:
          paymentMethods[Math.floor(Math.random() * paymentMethods.length)],
        transactionId: `txn_${Math.floor(Math.random() * 1000000000)}`,
        last4: Math.floor(Math.random() * 9000) + 1000,
        brand:
          paymentMethods[Math.floor(Math.random() * paymentMethods.length)] ===
            'credit_card'
            ? ['visa', 'mastercard', 'amex'][Math.floor(Math.random() * 3)]
            : null,
        status: paymentStatus,
      },
      notes: Math.random() > 0.7 ? 'Special delivery instructions' : '',
    });
  }

  return additionalOrders;
};

// Combine original orders with generated ones
const allOrders = [...mockOrders, ...generateAdditionalOrders()];

// Simulate API delay
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// POST /api/orders – create order (after payment success)
export const createOrder = async (orderData) => {
  if (USE_REAL_API) {
    const res = await fetch(`${API_BASE_URL}/orders`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify(orderData),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json?.message || 'Failed to create order');
    return json.data;
  }
  await delay(1000);
  const newOrder = {
    id: allOrders.length + 1,
    orderNumber: `ORD-2024-${(allOrders.length + 1).toString().padStart(3, '0')}`,
    ...orderData,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
  allOrders.push(newOrder);
  return newOrder;
};

export const getMyOrders = async (params = new URLSearchParams()) => {
  if (USE_REAL_API) {
    const url = new URL(`${API_BASE_URL}/orders/my`);
    for (const [k, v] of params.entries()) url.searchParams.set(k, v);
    const res = await fetch(url.toString(), { headers: { ...authHeaders() } });
    const json = await res.json();
    if (!res.ok) throw new Error(json?.message || 'Failed to fetch my orders');
    return json.data;
  }
  return (await fetchOrders(params)).orders;
};

// GET /api/orders – list orders with pagination, search, filters
export const fetchOrders = async (params = new URLSearchParams()) => {
  if (USE_REAL_API) {
    // Prefer admin endpoint when available
    const urlAdmin = new URL(`${API_BASE_URL}/admin/orders`);
    for (const [k, v] of params.entries()) urlAdmin.searchParams.set(k, v);
    let res = await fetch(urlAdmin.toString(), {
      headers: { ...authHeaders() },
    });
    if (!res.ok) {
      // Fallback to public orders if admin route not available
      const urlPublic = new URL(`${API_BASE_URL}/orders`);
      for (const [k, v] of params.entries()) urlPublic.searchParams.set(k, v);
      res = await fetch(urlPublic.toString(), {
        headers: { ...authHeaders() },
      });
    }
    const json = await res.json();
    if (!res.ok) throw new Error(json?.message || 'Failed to fetch orders');
    const orders = json?.data?.orders || json?.data || [];
    const pagination = json?.pagination || {
      page: Number(params.get('page') || 1),
      limit: Number(params.get('limit') || 10),
      total: Array.isArray(orders) ? orders.length : 0,
      totalPages: 1,
    };
    return { orders, pagination };
  }
  await delay(500);
  // mock fallback below
  let filteredOrders = [...allOrders];
  const search = params.get('search');
  if (search) {
    filteredOrders = filteredOrders.filter(
      (order) =>
        order.orderNumber.toLowerCase().includes(search.toLowerCase()) ||
        order.customerName.toLowerCase().includes(search.toLowerCase()) ||
        order.customerEmail.toLowerCase().includes(search.toLowerCase()) ||
        order.shippingAddress.city.toLowerCase().includes(search.toLowerCase())
    );
  }
  const status = params.get('status');
  if (status) {
    filteredOrders = filteredOrders.filter(
      (order) => order.status.toLowerCase() === status.toLowerCase()
    );
  }
  const paymentStatus = params.get('paymentStatus');
  if (paymentStatus) {
    filteredOrders = filteredOrders.filter(
      (order) =>
        order.paymentStatus.toLowerCase() === paymentStatus.toLowerCase()
    );
  }
  const shippingStatus = params.get('shippingStatus');
  if (shippingStatus) {
    filteredOrders = filteredOrders.filter(
      (order) =>
        order.shippingStatus.toLowerCase() === shippingStatus.toLowerCase()
    );
  }
  const startDate = params.get('startDate');
  const endDate = params.get('endDate');
  if (startDate || endDate) {
    filteredOrders = filteredOrders.filter((order) => {
      const orderDate = new Date(order.createdAt);
      if (startDate && orderDate < new Date(startDate)) return false;
      if (endDate && orderDate > new Date(endDate)) return false;
      return true;
    });
  }
  const sortBy = params.get('sortBy') || 'createdAt';
  const sortOrder = params.get('sortOrder') || 'desc';
  filteredOrders.sort((a, b) => {
    let aValue = a[sortBy];
    let bValue = b[sortBy];
    if (typeof aValue === 'string') {
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
    }
    if (sortOrder === 'asc')
      return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
    return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
  });
  const page = parseInt(params.get('page')) || 1;
  const limit = parseInt(params.get('limit')) || 10;
  const startIndex = (page - 1) * limit;
  const endIndex = startIndex + limit;
  const paginatedOrders = filteredOrders.slice(startIndex, endIndex);
  return {
    orders: paginatedOrders,
    pagination: {
      page,
      limit,
      total: filteredOrders.length,
      totalPages: Math.ceil(filteredOrders.length / limit),
    },
  };
};

// GET /api/orders/:id – order details
export const getOrder = async (id) => {
  if (USE_REAL_API) {
    const res = await fetch(
      `${API_BASE_URL}/orders/${encodeURIComponent(id)}`,
      { headers: { ...authHeaders() } }
    );
    const json = await res.json();
    if (!res.ok) throw new Error(json?.message || 'Failed to fetch order');
    return json.data;
  }
  await delay(300);
  const order = allOrders.find((o) => o.id === parseInt(id));
  if (!order) throw new Error('Order not found');
  return order;
};

// Backwards compatibility: some files import fetchOrder
export const fetchOrder = async (id) => getOrder(id);

export const cancelOrder = async (id, reason = '') => {
  if (USE_REAL_API) {
    const res = await fetch(
      `${API_BASE_URL}/orders/${encodeURIComponent(id)}/cancel`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ reason }),
      }
    );
    const json = await res.json();
    if (!res.ok) throw new Error(json?.message || 'Failed to cancel order');
    return json.data;
  }
  // mock fallback: mark as cancelled
  const idx = allOrders.findIndex((o) => o.id === parseInt(id));
  if (idx === -1) throw new Error('Order not found');
  allOrders[idx] = {
    ...allOrders[idx],
    status: 'cancelled',
    updatedAt: new Date().toISOString(),
  };
  return allOrders[idx];
};

export const trackOrder = async (orderNumber) => {
  if (USE_REAL_API) {
    // First try the track endpoint
    try {
      const res = await fetch(
        `${API_BASE_URL}/orders/track/${encodeURIComponent(orderNumber)}`
      );
      const json = await res.json();
      if (res.ok && json?.data) {
        // If track endpoint returns limited data, try to get full order details
        if (!json.data.totalAmount || !json.data.paymentStatus) {
          // Try to get full order details by searching through user's orders
          try {
            const ordersResponse = await getMyOrders(
              new URLSearchParams({ limit: '100' })
            );
            const orders = Array.isArray(ordersResponse)
              ? ordersResponse
              : ordersResponse?.data || [];
            const fullOrder = orders.find((o) => o.orderNumber === orderNumber);
            if (fullOrder) {
              return fullOrder;
            }
          } catch (e) {
            console.warn('Could not fetch full order details:', e);
          }
        }
        return json.data;
      }
    } catch (e) {
      console.warn('Track endpoint failed, trying alternative:', e);
    }

    // Fallback: try to find order in user's orders
    try {
      const ordersResponse = await getMyOrders(
        new URLSearchParams({ limit: '100' })
      );
      const orders = Array.isArray(ordersResponse)
        ? ordersResponse
        : ordersResponse?.data || [];
      const order = orders.find((o) => o.orderNumber === orderNumber);
      if (order) {
        return order;
      }
    } catch (e) {
      console.warn('Could not fetch user orders:', e);
    }

    throw new Error('Order not found');
  }

  // mock fallback: return complete order data
  const order = allOrders.find((o) => o.orderNumber === orderNumber);
  if (!order) throw new Error('Order not found');
  return order;
};

// PUT /api/orders/:id/status (admin) – update status
export const updateOrderStatus = async (id, statusData) => {
  if (USE_REAL_API) {
    // Admin endpoint
    const res = await fetch(
      `${API_BASE_URL}/admin/orders/${encodeURIComponent(id)}/status`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify(statusData),
      }
    );
    const json = await res.json();
    if (!res.ok)
      throw new Error(json?.message || 'Failed to update order status');
    return json.data;
  }
  await delay(800);
  const index = allOrders.findIndex((o) => o.id === parseInt(id));
  if (index === -1) throw new Error('Order not found');
  allOrders[index] = {
    ...allOrders[index],
    ...statusData,
    updatedAt: new Date().toISOString(),
  };
  return allOrders[index];
};

// POST /api/shipping/rates – call DHL rates API
export const getShippingRates = async (shippingData) => {
  await delay(1000);

  // Mock DHL rates response
  const mockRates = [
    {
      service: 'standard',
      name: 'DHL Standard',
      cost: 15.5,
      estimatedDays: 5,
      description: 'Standard delivery within 5 business days',
    },
    {
      service: 'express',
      name: 'DHL Express',
      cost: 25.0,
      estimatedDays: 2,
      description: 'Express delivery within 2 business days',
    },
    {
      service: 'overnight',
      name: 'DHL Overnight',
      cost: 45.0,
      estimatedDays: 1,
      description: 'Overnight delivery next business day',
    },
  ];

  return mockRates;
};

// POST /api/shipping/create – call DHL shipment API
export const createShipment = async (shipmentData) => {
  await delay(1500);

  const trackingNumber = `DHL${Math.floor(Math.random() * 1000000000)}`;

  return {
    shipmentId: `ship_${Math.floor(Math.random() * 1000000)}`,
    trackingNumber,
    status: 'created',
    estimatedDelivery: new Date(
      Date.now() + 5 * 24 * 60 * 60 * 1000
    ).toISOString(),
    label: `https://api.dhl.com/labels/${trackingNumber}.pdf`,
  };
};

// GET /api/shipping/:trackingNumber – fetch DHL tracking updates
export const getTrackingUpdates = async (trackingNumber) => {
  await delay(800);

  const mockTrackingEvents = [
    {
      timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
      status: 'picked_up',
      location: 'New York, NY',
      description: 'Package picked up from sender',
    },
    {
      timestamp: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
      status: 'in_transit',
      location: 'Chicago, IL',
      description: 'Package in transit to destination',
    },
    {
      timestamp: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
      status: 'out_for_delivery',
      location: 'Los Angeles, CA',
      description: 'Package out for delivery',
    },
  ];

  return {
    trackingNumber,
    status: 'in_transit',
    events: mockTrackingEvents,
    estimatedDelivery: new Date(
      Date.now() + 1 * 24 * 60 * 60 * 1000
    ).toISOString(),
  };
};

// POST /api/shipping/webhook – DHL sends status updates
export const handleShippingWebhook = async (webhookData) => {
  await delay(200);

  // In a real implementation, this would update the order status
  // based on DHL webhook notifications
  console.log('Shipping webhook received:', webhookData);

  return { success: true };
};

// DELETE /api/shipping/:shipmentId – cancel shipment
export const cancelShipment = async (shipmentId) => {
  await delay(1000);

  return {
    shipmentId,
    status: 'cancelled',
    cancelledAt: new Date().toISOString(),
  };
};

// Get order statuses for filters
export const fetchOrderStatuses = async () => {
  await delay(200);
  return ['pending', 'processing', 'shipped', 'delivered', 'cancelled'];
};

// Get payment statuses for filters
export const fetchPaymentStatuses = async () => {
  await delay(200);
  return ['pending', 'paid', 'failed', 'refunded'];
};

// Get shipping statuses for filters
export const fetchShippingStatuses = async () => {
  await delay(200);
  return ['not_shipped', 'preparing', 'in_transit', 'delivered', 'cancelled'];
};

// Get order statistics
export const fetchOrderStats = async () => {
  if (USE_REAL_API) {
    const res = await fetch(`${API_BASE_URL}/orders/stats`, {
      headers: { ...authHeaders() },
    });
    const json = await res.json();
    if (res.ok && json?.data) return json.data;
    // If stats endpoint not available, derive from first page of orders
    try {
      const { orders } = await fetchOrders(
        new URLSearchParams({ page: '1', limit: '100' })
      );
      const totalOrders = orders.length;
      const pendingOrders = orders.filter((o) => o.status === 'pending').length;
      const processingOrders = orders.filter(
        (o) => o.status === 'processing'
      ).length;
      const shippedOrders = orders.filter((o) => o.status === 'shipped').length;
      const deliveredOrders = orders.filter(
        (o) => o.status === 'delivered'
      ).length;
      const totalRevenue = orders.reduce(
        (sum, o) => sum + (o.totalAmount || 0),
        0
      );
      const averageOrderValue =
        totalOrders > 0 ? totalRevenue / totalOrders : 0;
      return {
        totalOrders,
        pendingOrders,
        processingOrders,
        shippedOrders,
        deliveredOrders,
        totalRevenue: Math.round(totalRevenue * 100) / 100,
        averageOrderValue: Math.round(averageOrderValue * 100) / 100,
      };
    } catch (e) {
      throw new Error(json?.message || 'Failed to fetch order stats');
    }
  }
  await delay(300);
  const totalOrders = allOrders.length;
  const pendingOrders = allOrders.filter((o) => o.status === 'pending').length;
  const processingOrders = allOrders.filter(
    (o) => o.status === 'processing'
  ).length;
  const shippedOrders = allOrders.filter((o) => o.status === 'shipped').length;
  const deliveredOrders = allOrders.filter(
    (o) => o.status === 'delivered'
  ).length;
  const totalRevenue = allOrders.reduce((sum, o) => sum + o.totalAmount, 0);
  const averageOrderValue = totalOrders > 0 ? totalRevenue / totalOrders : 0;
  return {
    totalOrders,
    pendingOrders,
    processingOrders,
    shippedOrders,
    deliveredOrders,
    totalRevenue: Math.round(totalRevenue * 100) / 100,
    averageOrderValue: Math.round(averageOrderValue * 100) / 100,
  };
};
